import { render } from "./Callback.vue?vue&type=template&id=644d7c92&scoped=true"
import script from "./Callback.vue?vue&type=script&lang=js"
export * from "./Callback.vue?vue&type=script&lang=js"

import "./Callback.vue?vue&type=style&index=0&id=644d7c92&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-644d7c92"

export default script